<template>
  <form id="team-form" @submit.prevent>

    <radio-box :question="getQuestionByTag('Q22')"  @onAnswer="onQ22Answer" v-model="formData['Q22']"></radio-box>

    <founder-details v-if="formData['Q22']" v-model="formData['foundersDetails']"
                     :number-of-founders="formData['Q22'] && FOUNDERS_MAP[formData['Q22']['title']]"></founder-details>
    <radio-box :question="getQuestionByTag('Q24')"
               v-model="formData['Q24']" v-if="(formData['Q22'] && formData['Q22']['tag'] !== 'A1')"></radio-box>
    <radio-box :question="getQuestionByTag('Q25')"
               v-model="formData['Q25']"></radio-box>
    <radio-box :question="getQuestionByTag('Q26')"
               v-model="formData['Q26']"></radio-box>
    <radio-box :question="getQuestionByTag('Q27')"
               v-model="formData['Q27']"></radio-box>
    <radio-box :question="getQuestionByTag('Q28')"
               v-model="formData['Q28']"></radio-box>
    <radio-box :question="getQuestionByTag('Q29')"
               v-model="formData['Q29']"></radio-box>
    <radio-box :question="getQuestionByTag('Q30')"
               v-model="formData['Q30']"></radio-box>
    <radio-box :question="getQuestionByTag('Q31')"
               v-model="formData['Q31']"></radio-box>
    <radio-box :question="getQuestionByTag('Q32')"
               v-model="formData['Q32']"></radio-box>
    <radio-box :question="getQuestionByTag('Q33')"
               v-model="formData['Q33']"></radio-box>
  </form>
</template>

<script>
import {FormsMixin} from "@/modules/calculator/forms/FormsMixin";
import RadioBox from "@/modules/calculator/components/RadioBox";
import FalconSelect from "@/shared/forms/FalconSelect";
import FounderDetails from "@/modules/calculator/components/FounderDetails";
import {FormValidation} from "@/shared/directives/formValidation";
import {FOUNDERS_MAP} from "@/modules/calculator/forms/constants";

export default {
  name: "TeamForm",
  mixins: [FormsMixin],
  components: { RadioBox, FalconSelect, FounderDetails},
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    formData: Object
  },
  data() {
    return {
      numberOfFounders: '',
      foundersDetails: {},
      formValidation: null,
      FOUNDERS_MAP,
    }
  },
  async mounted() {
      this.formValidation = new FormValidation('#team-form');
  },
  methods: {
    getData(){
      let data = this.formatAnswers();
      data['founders_details'] = JSON.parse(JSON.stringify(data['foundersDetails']))
      delete data['foundersDetails'];
      return data;
    },
    onQ22Answer(answer, question){
      if(FOUNDERS_MAP[answer.title] === 1 ) {
        delete this.formData['Q24'];
        delete this.formData['Q25'];
      }
    }
  }
}
</script>

<style scoped>

</style>
